'use client'

import Image from '@/components/image'
import { useTranslations } from 'next-intl'
import React from 'react'

export default function Layout({ children }) {
  const t = useTranslations()

  return (
    <div className='flex min-h-dvh bg-[#161A1E]'>
      <div className='relative hidden flex-1 justify-center md:flex'>
        <Image
          fill={true}
          src='/blur.webp'
          alt='background'
          className='absolute object-cover w-full h-full left-0 top-0 right-0 bottom-0'
        />
        <div className='relative flex flex-col items-center justify-center gap-y-5'>
          <Image src='/logo.svg' alt='Mfans' width={327} height={120} />
          <h2
            className='text-sm font-normal text-[#F9F9F9]'
            dangerouslySetInnerHTML={{ __html: t('page.login.slogan') }}
          />
        </div>
      </div>
      <div className='flex h-full flex-1 justify-center'>
        <div className='mb-10 w-[344px] pt-24'>
          <main>{children}</main>
        </div>
      </div>
    </div>
  )
}
